// common
import Dashboard from "./dashboard.json";
import Module from "./module.json";
import Sidebar from "./sidebar.json";
import Header from "./header.json";
import HrmEmployeeFilter from "./HrmEmployeeFilter.json";

// hrm
import acrList from "./hrm/acrList.json";
import aprList from "./hrm/aprList.json";
import DossierList from "./hrm/dossierList.json";
import DossierDetails from "./hrm/dossierDetails.json";
import CentralAttendance from "./hrm/centralAttendance.json";
import CreateNewLoan from "./hrm/createNewLoan.json";
import CreatePromotions from "./hrm/createPromotion.json";
import CreateTransfer from "./hrm/createTransfer.json";
import Employee from "./hrm/employee.json";
import EmployeeTypes from "./hrm/employeeTypes.json";
import Employees from "./hrm/employees.json";
import Gpf from "./hrm/gpf.json";
import GpfHistory from "./hrm/gpfHistory.json";
import GpfList from "./hrm/gpfList.json";
import InitiatePromotion from "./hrm/initiatePromotion.json";
import InstallmentDetails from "./hrm/installmentDetails.json";
import LeaveApply from "./hrm/leaveApply.json";
import LeaveHistory from "./hrm/leaveHistory.json";
import LeaveList from "./hrm/leaveList.json";
import LeaveSettings from "./hrm/leaveSettings.json";
import LeaveUpdate from "./hrm/leaveUpdate.json";
import PermanentList from "./hrm/permanentList.json";
import Position from "./hrm/position.json";
import PositionList from "./hrm/positionList.json";
import PositionListTree from "./hrm/positionListTree.json";
import PromotionCandidates from "./hrm/promotionCandidates.json";
import PromotionList from "./hrm/promotionList.json";
import ProvidentFund from "./hrm/providentFund.json";
import punishmentHistoryList from "./hrm/punishmentHistoryList.json";
import Resignation from "./hrm/resignation.json";
import ResignationList from "./hrm/resignationList.json";
import Retirement from "./hrm/retirement.json";
import RetirementList from "./hrm/retirementList.json";
import seniorityList from "./hrm/seniorityList.json";
import deputationList from "./hrm/deputationList.json";
import releaseList from "./hrm/releaseList.json";
import release from "./hrm/release.json";
import deceased from "./hrm/deceased.json";
import TransferCandidates from "./hrm/transferCandidates.json";
import TransferDetails from "./hrm/transferDetails.json";
import Transfers from "./hrm/transfers.json";
import HRMSettings from "./hrm/settings.json";
import Reports from "./hrm/reports.json";
import DeceasedList from "./hrm/deceasedList.json";
import Termination from "./hrm/termination.json";
import TerminationList from "./hrm/terminationList.json";
import extraPositionInformations from "./hrm/extraPositionInformations.json";
import interchangeTransfers from "./hrm/interchangeTransfers.json";
import interchangeTransferDetails from "./hrm/interchangeTransferDetails.json";
import FileInquiryList from "./hrm/fileInquiryList.json";
import FileInquiry from "./hrm/fileInquiry.json";

import BudgetList from "./inventory/budgetList.json";
import CreateBudget from "./inventory/createBudget.json";
import CreateProcurements from "./inventory/createProcurements.json";
import CreateProductBatch from "./inventory/createProductBatch.json";
import InventoryEmployees from "./inventory/employees.json";
import ForecastingList from "./inventory/forecastingList.json";
import Maintenance from "./inventory/maintenance.json";
import ProcurementsDetails from "./inventory/procurementsDetails.json";
import ProcurementsList from "./inventory/procurementsList.json";
import ProductsList from "./inventory/productList.json";
import Requisition from "./inventory/requisition.json";
import InventoryRoomConference from "./inventory/roomConference.json";
import InventoryRoomConfig from "./inventory/roomConfiguration.json";
import InventorySettings from "./inventory/settings.json";
import SoftwareInventory from "./inventory/softwareInventory.json";
import InventoryStock from "./inventory/stock.json";
import Warranty from "./inventory/warranty.json";

// procurement
import addNewPackage from "./procurement/addNewPackage.json";
import addNewAnnualProcurement from "./procurement/addNewProcurement.json";
import addNewVendorsForm from "./procurement/addNewVendorsForm.json";
import annualProcurementPlan from "./procurement/annualProcurementPlan.json";
import annualProcurementPlanDetails from "./procurement/annualProcurementPlanDetails.json";
import committee from "./procurement/committee.json";
import committeeTable from "./procurement/committeeTable.json";
import ProcurementCreate from "./procurement/createNewProcurement.json";
import procurementCreateTable from "./procurement/createProcurementList.json";
import Demand from "./procurement/demand.json";
import procurementDetails from "./procurement/procurementDetails.json";
import Procurements from "./procurement/procurements.json";
import vendorsTable from "./procurement/vendorsTable.json";

// task
import AllTasks from "./taskManagement/allTasks.json";
import AssignedSubTasks from "./taskManagement/assignedSubTasks.json";
import SharedSubTasks from "./taskManagement/sharedSubTasks.json";
import AssignedTasks from "./taskManagement/assignedTasks.json";
import OwnTasks from "./taskManagement/ownTasks.json";
import TaskManagementSettings from "./taskManagement/settings.json";
import SharedTasks from "./taskManagement/sharedTasks.json";
import SubTasks from "./taskManagement/subTasks.json";
import ArchivedTasks from "./taskManagement/archivedTasks.json";

import CreateTicket from "./tickets/createTicket.json";
import TicketDetails from "./tickets/ticketDetails.json";
import TicketList from "./tickets/ticketList.json";
import TicketSettings from "./tickets/ticketSettings.json";

// Notification
import NotificationList from "./notification/notificationList.json";

const translation = {
  translation: {
    EMPLOYEES: Employees,
    TRANSFERS: Transfers,
    INTERCHANGE_TRANSFERS: interchangeTransfers,
    RETIREMENT: Retirement,
    RETIREMENT_LIST: RetirementList,
    SIDEBAR: Sidebar,
    HEADER: Header,
    HRM_EMPLOYEE_FILTER: HrmEmployeeFilter,
    PROMOTION_CANDIDATES: PromotionCandidates,
    TRANSFER_CANDIDATES: TransferCandidates,
    CREATE_PROMOTIONS: CreatePromotions,
    PROMOTION_LIST: PromotionList,
    EMPLOYEE: Employee,
    ATTENDANCE: CentralAttendance,
    EMPLOYEE_TYPES: EmployeeTypes,
    DASHBOARD: Dashboard,
    MODULE: Module,
    INITIATE_PROMOTION: InitiatePromotion,
    ACR_LIST: acrList,
    APR_LIST: aprList,
    SENIORITY_LIST: seniorityList,
    DEPUTATION_LIST: deputationList,
    RELEASE_LIST: releaseList,
    RELEASE_DETAILS: release,
    DECEASED_DETAILS: deceased,
    PROVIDENT_FUND: ProvidentFund,
    CREATE_NEW_LOAN: CreateNewLoan,
    INSTALLMENT_DETAILS: InstallmentDetails,
    PUNISHMENT_HISTORY_LIST: punishmentHistoryList,
    PERMANENT_LIST: PermanentList,
    RESIGNATIONS: ResignationList,
    RESIGNATION: Resignation,
    LEAVE_LIST: LeaveList,
    LEAVE_HISTORY: LeaveHistory,
    LEAVE_APPLY: LeaveApply,
    LEAVE_UPDATE: LeaveUpdate,
    LEAVE_SETTINGS: LeaveSettings,
    POSITION: Position,
    POSITION_LIST: PositionList,
    POSITION_LIST_TREE: PositionListTree,
    GPF_LIST: GpfList,
    DOSSIER_LIST: DossierList,
    DOSSIER_DETAILS: DossierDetails,

    GPF_HISTORY: GpfHistory,
    GPF: Gpf,
    CREATE_TRANSFER: CreateTransfer,
    TRANSFER: TransferDetails,
    INTERCHANGE_TRANSFER: interchangeTransferDetails,
    HRM_SETTINGS: HRMSettings,
    REPORTS: Reports,
    DECEASED_LIST: DeceasedList,
    TERMINATION_LIST: TerminationList,
    TERMINATION_DETAILS: Termination,
    EXTRA_POSITION_INFORMATIONS: extraPositionInformations,
    FILE_INQUIRY_LIST: FileInquiryList,
    FILE_INQUIRY: FileInquiry,

    // inventory
    PROCUREMENTS_LIST: ProcurementsList,
    CREATE_PROCUREMENTS: CreateProcurements,
    PROCUREMENTS_DETAILS: ProcurementsDetails,
    INVENTORY_SETTINGS: InventorySettings,
    INVENTORY_STOCK: InventoryStock,
    INVENTORY_PRODUCT_LIST: ProductsList,
    INVENTORY_EMPLOYEE: InventoryEmployees,
    INVENTORY_ROOM_CONFIG: InventoryRoomConfig,
    INVENTORY_ROOM_CONFERENCE: InventoryRoomConference,
    INVENTORY_CREATE_PRODUCT_BATCH: CreateProductBatch,
    INVENTORY_BUDGET_LIST: BudgetList,
    INVENTORY_CREATE_BUDGET: CreateBudget,
    INVENTORY_FORECASTING_LIST: ForecastingList,
    INVENTORY_REQUISITION: Requisition,
    INVENTORY_WARRANTY: Warranty,
    INVENTORY_MAINTENANCE: Maintenance,
    SOFTWARE_INVENTORY: SoftwareInventory,

    // procurement
    PROCUREMENT_ANNUAL_PLAN: annualProcurementPlan,
    PROCUREMENT_VENDORS_TABLE: vendorsTable,
    PROCUREMENT_CREATE_TABLE: procurementCreateTable,
    PROCUREMENT_COMMITTEE_TABLE: committeeTable,
    PROCUREMENT_ADD_VENDORS: addNewVendorsForm,
    PROCUREMENT_ADD_NEW: addNewAnnualProcurement,
    PROCUREMENT_CREATE: ProcurementCreate,
    PROCUREMENT_DETAILS: procurementDetails,
    PROCUREMENT_ADD_PACKAGE: addNewPackage,
    PROCUREMENT_DEMAND: Demand,
    PROCUREMENT_PROCUREMENTS: Procurements,
    COMMITTEE: committee,
    APP_DETAILS: annualProcurementPlanDetails,

    // task management
    TM_SETTINGS: TaskManagementSettings,
    TM_ALL_TASKS: AllTasks,
    TM_OWN_TASKS: OwnTasks,
    TM_SHARED_TASKS: SharedTasks,
    TM_ASSIGNED_TASKS: AssignedTasks,
    TM_ASSIGNED_SUB_TASKS: AssignedSubTasks,
    TM_SHARED_SUB_TASKS: SharedSubTasks,
    TM_SUB_TASKS: SubTasks,
    TM_ARCHIVED_TASKS: ArchivedTasks,

    // tickets
    TICKETS: {
      TICKET_LIST: TicketList,
      CREATE: CreateTicket,
      DETAILS: TicketDetails,
      SETTINGS: TicketSettings,
    },

    // notification
    NOTIFICATIONS: NotificationList,
  },
};

export default translation;
